
export const generateCO2Data = (pvGeneration, co2) => {
  const value = pvGeneration * co2;
  const total = value / (1000 * 1000 * 1000);
  return total
};
